<template>
  <div class="" style="overflow:hidden !important">
    <div class="portal-bg">
      <div class="portal-text"></div>
    </div>
    <div class="login-user my-5" style="overflow:hidden !important">
      <!-- <div class="loginLoader" v-if="loading"></div> -->
      <div class="mx-0 px-0 " style="overflow:hidden !important">
        <div class="container h-100">
          <div class="row d-flex card-holder">
            <div class="">
              <div class="card" style="">
                <div class="ml-4 mt-2"></div>
                <div class="row card-text">
                  <div class="col-sm-12">
                    <div class="card-body px-5 py-1" style="margin-top: 4%;">
                      <div class="logo-container text-center mb-2">
                        <img class="logo scala" :src="logo" />
                      </div>
                      <div class="mb-5"></div>  
      
                      <form @submit.prevent="submit" class="login-form">
                        <p class="text-center">We sent code to your Email: {{ email }} </p>
                        <div class="mb-4 row">
                          <label for="form3Example1cg" class="col-sm-3 col-form-label font-weight-bold email-pass-text">Code:</label>
                          <div class="col-sm-9 email-pass">
                            <input type="number" id="form3Example1cg" class="form-control"  v-model="resetForm.code" required/>
                          <!-- <div class="" style="color: red;" v-if="emailError">Please provide email</div> -->
                          </div>
                          <div class="resend-code-container">
                            <div>
                              <p style="margin:0;">Didn't receive the code?</p>
                              <a class="resend" id="resend-link" @click.prevent="resendCode">Resend code</a>
                              <span id="timer"></span>
                            </div>
                          </div>
                        </div>
                        
        
                     
                        
                        <div class="d-flex justify-content-center pt-3">
                          <button @click.prevent="takeMeHome"  type="submit" class="btn btn-lg text-white login-btn font-weight-bold">Submit</button>
                        </div>

                        <div class="d-flex justify-content-center pt-3">
                          <p @click.prevent="backToLogin" class="back-to-login-text"> Go back to login</p>
                        </div>
                       
                      </form>
      
                    </div>
                  </div>
                </div>
                
                
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { setCookie, deleteCookie } from '../js/composables';
import { encryptData } from '../js/utils/encrypt';

import loginimage from '../assets/Stratacachelogo.png';
import { routeNames } from '../js/routeNames';
import { decryptData } from '../js/utils/encrypt';
import posthog from 'posthog-js';





export default {
  name: 'Twofa',
  props: ['email'],
  components:{
    // props: ['email']
  },
  data(){
    return{
      logo: loginimage,
      resetForm: {
        code: ''
      },
      test: 'test',
      timeLeft: 30 //This is to set the timer to wait to send a resend link.
    };
  },
  computed: {
    routeNames: () => {
      return routeNames;
    },
	
  },
  mounted(){
    var resendLink = document.getElementById('resend-link');
    var timer = document.getElementById('timer');
    this.timeLeft = 30;
    const countdown = setInterval(() => {
      this.timeLeft--;
      timer.innerHTML = '(' + this.timeLeft + ')';
      if (this.timeLeft === 0) {
        clearInterval(countdown);
        resendLink.style.pointerEvents = 'auto';
        resendLink.style.color = '#EE3234';
        timer.style.display = 'none';
      }
    }, 1000);
    resendLink.style.pointerEvents = 'none';
    resendLink.style.color = 'grey';
    resendLink.addEventListener('mouseenter', () => {
      resendLink.style.textDecoration = 'underline'; // add underline on hover
    });
    resendLink.addEventListener('mouseleave', () => {
      resendLink.style.textDecoration = 'none'; // remove underline when not hovering
    });
    timer.innerHTML = '('+this.timeLeft+')';
  },
  beforeUnmount() {
    clearInterval(this.countdown); // clear the interval when the component is destroyed
  },
  methods: {
    takeMeHome(){
      // this.$router.push({name: routeNames.home });
      if(this.resetForm.code != ''){
        axios.post(this.$hostName + '/verify/store', {two_factor_code: this.resetForm.code})
        .then((response) => {
          if(response.status == 200){

            const secretKey = process.env.KEY || 'myscecretkey';
            let token = response.data.data.token;
            const encryptedTokenData = encryptData(token, secretKey);
            setCookie('2faToken', encryptedTokenData, 1);
            this.$router.push({name: routeNames.home });

            //PostHog related code
            var encryptedEmailID = localStorage.getItem('Email');
            const email = decryptData(encryptedEmailID, secretKey).replace(/['"]+/g, '');
            posthog.identify(email, {
              email: email,
            });
            posthog.capture('login', { email: this.email });
            
          }
          else if(response.status == 203){
            Swal.fire({
              text: response.data,
              // confirmButtonText: 'Ok',
              icon: 'error',
              timer: 5000,
              showCancelButton: false,
              showConfirmButton: false
            });
          }
          else if(response.status == 202){
            Swal.fire({
              text: response.data,
              // confirmButtonText: 'Ok',
              icon: 'warning',
              timer: 5000,
              showCancelButton: false,
              showConfirmButton: false
            });
          }
          else if(response.status==403){
            console.log(response.data);
            this.$router.push({name: routeNames.login });
          }
          else{
            console.log(response.data);                  
          }
        });
      } else{
        Swal.fire({
          text: 'Please enter OTP',
          confirmButtonText: 'Ok',
        });
      }
      
    },

    backToLogin(){
      if (routeNames.login == this.$router.currentRoute.name) {
        return;
      }
      axios
        .post(this.$hostName + '/logout', null)
        .then(() => {
          this.$router.push({ name: routeNames.login });
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
        })
        .finally(() => {
          // localStorage.removeItem('token');
          deleteCookie('token');
          deleteCookie('2faToken');
          localStorage.removeItem('Permissions');
          localStorage.removeItem('username');
          localStorage.removeItem('Role');
          localStorage.removeItem('EmployeeID');
          localStorage.removeItem('Email');
          localStorage.removeItem('celebrationGIF');
          location.reload();
        });
    },
    resendCode(){
      const resendLink = document.getElementById('resend-link');
      const timer = document.getElementById('timer');
      clearInterval(this.countdown); // clear the previous countdown interval
      this.timeLeft = 30; // reset timeLeft to 30 seconds
      timer.style.display = 'inline'; // show the timer element again
      this.countdown = setInterval(() => {
        this.timeLeft--;
        timer.innerHTML = '(' + this.timeLeft + ')';
        if (this.timeLeft === 0) {
          clearInterval(this.countdown);
          resendLink.style.pointerEvents = 'auto';
          resendLink.style.color = '#EE3234';
          timer.style.display = 'none';
        }
      }, 1000);
      resendLink.style.pointerEvents = 'none';
      resendLink.style.color = 'grey';
      resendLink.addEventListener('mouseenter', () => {
        resendLink.style.textDecoration = 'underline'; // add underline on hover
      });
      resendLink.addEventListener('mouseleave', () => {
        resendLink.style.textDecoration = 'none'; // remove underline when not hovering
      });
      timer.innerHTML = '(' + this.timeLeft + ')';
              axios
                .get(this.$hostName + '/verify/resend')
                .then((response) => {
                  if(response.status == 201){
                    console.log('success', response.data);
                    Swal.fire({
                      text: response.data,
                      // confirmButtonText: 'Ok',
                      icon: 'success',
                      timer: 5000,
                      showCancelButton: false,
                      showConfirmButton: false
                    });
                  }
                  else if(response.status==200){
                    Swal.fire({
                      text: response.data,
                      confirmButtonText: 'Ok',
                    });
                  }
                  else{
                    console.log(response.data);                  
                  }
                 
                })
                .catch((error) => {
                      // this.errors = error.response.data.errors;
                      console.log(error.response.data.errors);
                    })
                .finally(() => {
                      // if (this.errors.email) {
                });
    }
  }
};
</script>

<style scoped>
.resend-code-container{
  padding: 10px 0;
}
#resend-code {
  display: flex;
  align-items: center;
}
#timer{
  margin-left: 5px;
  font-weight: bold;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
.backBtn{
  position: absolute;
  left: 40px;
  top: 15px;
  /* width: 60px; */
  border-radius: 10px;
  width: 60px;
  padding: 0px;
  /* position: absolute; */
  background-color: #EE3234;
  /* bottom: -40px; */
}

.portal-bg{
  background-image: url("../assets/Portal_Bg.png");
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0px;
  background-size: cover;
  overflow:hidden;
  display: flex;
  justify-content: center;
}

.portal-text{
  background-image: url("../assets/Portal_Bg_Text.png");
  position: absolute;
  top: 3%;
  width: 450px;
  height: 200px;
  background-size: cover;
}

.container {
  display:flex;
  justify-content: center;
  width: 1140px; /* Assign a value */
  height: 420px; /* Assign a value */
  margin: auto;
  overflow: hidden;
}

.card-holder{
  position: absolute;
  top: 40vh;
}

.card{
   box-shadow: 0px 2px 22px grey;
   width:36rem;
   height:22rem;
   border-radius: 20px;
   top: -30px;
}

.card-text{
  font-family: 'Montserrat';
}

.btn:focus {
  outline: none !important;
  box-shadow: none !important;
}
.login-btn {
  border-radius: 10px;
  width: 150px;
  position: absolute;
  background-color: #EE3234;
  bottom: -60px;
}
.btn-success:hover {
  color: #fff;
  background-color: #f35b5d;
  border-color: #f35b5d;
  -webkit-transform: translateY(-1px);
}

.login-form{
  height: 130px;
}

.email-pass-text{
  max-width: 28%;
}

.email-pass{
  max-width: 72%;
}

.resend{
  /* position: absolute;
  top: 200px;
  left: 62px; */
}
.resend:hover{
  color: #EE3234 !important;
  cursor: pointer;
}

.back-to-login-text{
  color: black;

}
.back-to-login-text:hover{
  cursor: pointer;
  color: #EE3234;
  border-bottom: 1px solid #EE3234;
}


@media screen and (max-width: 1300px) {
  .portal-text{
    width: 350px;
    height: 150px;
    background-size: cover;
    top: 00px;
  }

  .card{
    width:32rem;
    height: 22rem;
    top: -60px;
  }

}

@media only screen and (max-width: 575.98px) {
  .portal-text{
    width: 250px;
    height: 100px;
    background-size: cover;
    top: 30px;            /* from 130 to 30px */
  }

  .container {
    padding: 0;
    margin: none;
    width: 100% !important;
    bottom: 0;
    z-index: 998;
    position: absolute;
    left: 53%;
    transform: translate(-50%, 0);
    overflow-x: hidden !important;
  }

  .card{
    width: 20rem;
    height: 24rem;
    position: absolute;
    left: 50%;
    transform: translate(-50%);                          /* changed from -26.5% to 0 */
    top: -100px;                           /* from -70px to -100px */
  }

  .login-form{
  height: 165px;
  }

  .email-pass-text{
  max-width: 33%;
  padding-left: 0px;
  padding-right: 0px;
  }

  .email-pass{
  max-width: 67%;
  }

  .back-to-login-text{
  color: black;

}
.back-to-login-text:hover{
  cursor: pointer;
  color: #EE3234;
  border-bottom: 1px solid #EE3234;
}

}

</style>